import React from 'react'
import Grid from '@mui/material/Grid'
import styles from './Body-hr.module.css'

import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grow from '@mui/material/Grow';

const humanResourcesSection = {
  // 'COVID-19 Symptom Questionnaire': {
  //   href: 'https://blogs.molloy.edu/covid-19-questionnaire',
  //   img: require('../../../../assets/covid_questionnaire.png'),
  //   p: "This form must be filled out before each visit to Molloy's campuses."
  // },
  '32BJS': {
    href: 'https://www.32bjfundsemployer.org/',
    img: require('../../../../assets/32bjs.png'),
    p: ""
  },
  '4 Imprint': {
    href: 'https://www.4imprint.com/',
    img: require('../../../../assets/4-imprint.png'),
    p: ""
  },
  'AAUP - American Association of University Professors/Survey': {
    href: 'https://research.aaup.org/',
    img: require('../../../../assets/aaup.png'),
    p: ""
  },
  "Access": {
    href: 'https://www.microsoft.com/en-us/microsoft-365/access',
    img: require('../../../../assets/access.png'),
    p: ""
  },
  "ADP": {
    href: 'https://online.adp.com/signin/v1/?APPID=WFNPortal&productId=80e309c3-7085-bae1-e053-3505430b5495&returnURL=https://workforcenow.adp.com/&callingAppId=WFN',
    img: require('../../../../assets/adp.png'),
    p: ''
  },
  "Aetna": {
    href: 'https://www.myplanportal.com/pssel/loginPS.fcc?TYPE=167772161&REALMOID=06-bc796e40-61b5-478f-93c2-32165adcca17&GUID=0&SMAUTHREASON=5&METHOD=GET&SMAGENTNAME=-SM-FlJktFVXgYFB7TA1FZ0ChXIDilQR6SBkKoygDSZ79Asr0MzNf0j6l07%2bfR2Or3db&TARGET=-SM-HTTPS%3a%2f%2fwww.myplanportal.com%2fpssel%2fjsp%2frouting.jsp',
    img: require('../../../../assets/aetna.png'),
    p: ''
  },
  "Amazon": {
    href: 'https://www.amazon.com',
    img: require('../../../../assets/amazon.png'),
    p: ''
  },
  'Calendly': {
    href: 'https://calendly.com/login',
    img: require('../../../../assets/calendy.png'),
    p: ""
  },
  'Carebridge': {
    href: 'https://identity.personaladvantage.com/realms/carebridge/protocol/saml?SAMLRequest=jZLBbsIwEETvfEXkO7EDJCFWCKJFVZFohYD20EvlOAasJjb1OlD%2Bvk4oghPq0aPdmbe7Tsc%2FVekdhAGp1QgFPkHjrJNOartTS%2FFdC7Ceq1AwQrVRVDOQQBWrBFDL6WryMqc9n9C90VZzXSJvNh2hz82GB5yF0TCOc06ChCeMR0WUkzAJQp4Eg3gY80EwCAny3i%2FZzse1A9RipsAyZZ1EemGXxN0gWhNC%2BxHtJx%2FImzooqZhtu3bW7oFiLAuhrLQnf%2B%2F8tGIlKw7Og22Fz3WFjWBlBZgzI3Iji63AF2QMrHLci7%2Fng1SFVNv74%2BbnIqDP6%2FWiuxSFNIJb5E0AhGm4HrWCuhJmJcxBcvG2nF9Jj8ejf%2BVQ%2BtgCMrfxFqXnIMsyZ%2FwLZWkj0HYn5nwG2ij34dgFAmX%2FjUzxTVCWvjrP2XShS8lP3pM2FbP3IxtFFt1NW0qbC0iw7h4IZym%2B%2FUtZ5xc%3D&RelayState=bBxtkmWx7ETSq9FAKfoxseZSeDgPN5OmCXGaArb7&SigAlg=http%3A%2F%2Fwww.w3.org%2F2001%2F04%2Fxmldsig-more%23rsa-sha256&Signature=m9d1pEn2NKtghFw52fdFKWKJ2rUAQRQt0tvFDAIoDSjW9dUiLAdI91XOAdFUWm9QtnseAeEc%2FAuBxiyK%2FoAt5EahgY33xU3YerG%2Fs234SGRmqc1XEfhMiG8rLNC50V87KIWSrDPQ7J3fYc74Z1FI64KrIHto3qdokBao%2FTb4NdBTug7hVX%2FgLXKMzc4EawXTyi5fRIjEFe6HtoBzTWumd6L%2BHEPVm%2FDexxe6wQejJIygBpaKktEWTDiS3YBGNGv%2BqZ8jE%2BErKCfyILdQn4pJfWCrURCx8%2FkSto3kQAe4ePsCGa0lYSexYRPTp1DeoUnoLn96IWsbeapnAAT%2FKRu7cQ%3D%3D',
    img: require('../../../../assets/carebridge.png'),
    p: ""
  },
  // "Cigna": {
  //     href: 'https://cignaforemployers.cigna.com/public/app/signin',
  //     img: require('../../../../assets/cigna.png'),
  //     p: ""
  // },   
  'Cobra': {
    href: 'https://padmin.com/',
    img: require('../../../../assets/cobra.png'),
    p: ""
  },
  'Concord': {
    href: 'https://secure.concordnow.com/#/login',
    img: require('../../../../assets/concord.png'),
    p: ""
  },
  'CUPA HR': {
    href: 'https://www.cupahr.org/',
    img: require('../../../../assets/cupa.png'),
    p: ""
  },
  'Department of Labor - Unemployment': {
    href: 'https://dol.ny.gov/',
    img: require('../../../../assets/department_of_labor.png'),
    p: ""
  },
  'Difference Card': {
    href: 'https://www.differencecard.com/account-login/',
    img: require('../../../../assets/difference-card.png'),
    p: ""
  },
  'Diverse Jobs': {
    href: 'https://diversejobs.net/',
    img: require('../../../../assets/diverse_jobs.png'),
    p: ""
  },
  // 'EmblemHealth': {
  //   href: 'https://portals5.emblemhealth.com/Groups/Login.aspx?ReturnUrl=%2fGroups',
  //   img: require('../../../../assets/emblemHealth.png'),
  //   p: ""
  // },
  // 'Empire': {
  //   href: 'https://www.empireblue.com/',
  //   img: require('../../../../assets/beacon.jpg'),
  //   p: ""
  // },
  'Hartford': {
    href: 'https://www.thehartford.com/account-access',
    img: require('../../../../assets/hartford.png'),
    p: ""
  },
  'HERC - Higher Education Recruitment Consortium': {
    href: 'https://www.hercjobs.org/',
    img: require('../../../../assets/hercjobs.png'),
    p: ""
  },
  'HigherEdJobs': {
    href: 'https://www.higheredjobs.com/',
    img: require('../../../../assets/higher_ed_jobs.png'),
    p: ""
  },
  'H.R. Forms': {
    href: 'https://www.molloy.edu/about/administration/human-resources/forms-human-resources',
    img: require('../../../../assets/hr-forms.png'),
    p: ""
  },
  'H.R. Form - Action': {
    href: 'https://forms.office.com/Pages/ResponsePage.aspx?id=bSl5yj94AEmWHqscc8qGjovi8Z9dxS9BmvnRetuG0q1UMjBGTjk1S1BRRjBOMllERlE1MEFSRFFaTy4u',
    img: require('../../../../assets/hr-form-action.png'),
    p: ""
  },
  'H.R. Policies': {
    href: 'https://policylibrary.molloy.edu/policies',
    img: require('../../../../assets/hr-policies.png'),
    p: ""
  },
  'Kahoot': {
    href: 'https://kahoot.com',
    img: require('../../../../assets/kahoot.png'),
    p: ""
  },
  'Legal Shield': {
    href: 'https://classic.shieldatwork.com/init',
    img: require('../../../../assets/legal_shield.png'),
    p: ""
  },
  'Lessings': {
    href: 'https://cs.lessings.com',
    img: require('../../../../assets/lessings.png'),
    p: ""
  },
  'LibApps': {
    href: 'https://molloyu.libapps.com/libapps/login.php?site_id=8789&target=%2Fadmin%2Fhome',
    img: require('../../../../assets/libapps.png'),
    p: ""
  },
  'LinkedIn': {
    href: 'https://www.linkedin.com/uas/login',
    img: require('../../../../assets/linkedin.png'),
    p: ""
  },
  // 'MetLife': {
  //   href: 'https://online.metlife.com/edge/web/public/uslogin?accesstype=employer',
  //   img: require('../../../../assets/metlife.png'),
  //   p: ""
  // },
  'NAVEX Ethics Point': {
    href: 'https://secure.ethicspoint.com/domain/en/default_reporter.asp',
    img: require('../../../../assets/navex.png'),
    p: ""
  },
  'Order Molloy Envelopes': {
    href: 'https://mydocs.four51storefront.com/MolloyU/catalog/',
    img: require('../../../../assets/order-envelopes.png'),
    p: ""
  },
  'People Systems': {
    href: 'https://www.prudential.com/giemployeraccess',
    img: require('../../../../assets/people-systems.png'),
    p: ""
  },
  'Prudential': {
    href: 'https://www.prudential.com/giemployeraccess',
    img: require('../../../../assets/prudential.png'),
    p: ""
  },
  // 'Pyramed - Vaccine Portal': {
  //   href: 'https://p5.pyramed.online/logon/LogonPoint/tmindex.html',
  //   img: require('../../../../assets/pyramed.png'),
  //   p: ""
  // },
  'SHRM - Society for Human Resources Management': {
    href: 'https://login.shrm.org/?request_id=idABB2B51FDE0160&relay_state=id-d361cf32-c48b-416d-a72b-0222907a6c8d&issuer=aHR0cHM6Ly9zc28uc2hybS5vcmcvSURCVVMvU0hSTS9JRFAvU0FNTDIvTUQ=&target=aHR0cHM6Ly9zc28uc2hybS5vcmcvSURCVVMvU0hSTS9NWVNIUk0tT1BFTklELVJQLVNQLVBST1hZL1NBTUwyL01E',
    img: require('../../../../assets/shrm.png'),
    p: ""
  },
  'TIAA': {
    href: 'https://www.tiaa.org/public/',
    img: require('../../../../assets/tiaa.png'),
    p: ""
  },
  'Touchcare': {
    href: 'https://broker.touchcare.com/login',
    img: require('../../../../assets/touchcare.png'),
    p: ""
  },
  'Tuition Exchange': {
    href: 'https://te.tuitionexchange.org/applicantsignin',
    img: require('../../../../assets/tuition-exchange.png'),
    p: ""
  },
  'Tuition Remission Form': {
    href: 'https://forms.office.com/Pages/ResponsePage.aspx?id=bSl5yj94AEmWHqscc8qGjid0DxdtCyVJtI9q5MD_b7tUNVA1UEI2Mk1IUEZWNVBHREVVOEhJWEFFUy4u',
    img: require('../../../../assets/tuition-exchange.png'),
    p: ""
  },
  'Union': {
    href: 'https://www.32bjfundsemployer.org/',
    img: require('../../../../assets/union.png'),
    p: ""
  },
  'Vector Solutions': {
    href: 'https://molloy-ny.safecolleges.com/training/home',
    img: require('../../../../assets/vector_solutions.png'),
    p: ""
  },
  'WageWorks': {
    href: 'https://api.my.healthequity.com/identity/Login?returnUrl=%2Fidentity%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3Dapps-v5-employer-auth-client%26redirect_uri%3Dhttps%253A%252F%252Femployer.wageworks.com%252Foidc%252Fauthorize%26response_type%3Dcode%2520id_token%2520token%26scope%3Dopenid%2520profile%2520apps-v5-employer-auth-api%26state%3DOpenIdConnect.AuthenticationProperties%253DuhDCPbyY433P25f_2lVWq40B4pU3m6W6NxGKNmwyNOd_ox0AR_abtRYbeCz3AVBaAAkdbMBaU6eLNqYAHT5cq1x3vdmvnmVKNP1-59ZB_o7oDLwDEy7qlV3jX3wsMXK36XdUheME3KbgXOlXf7_sALK7211Iohlzum5m1U61WxneSsGDkcomQp38EU-KyvYyQY6Cw_etwFTsR0jY9yYG0w%26response_mode%3Dform_post%26nonce%3D638882227026246404.ODVhNDA2MTUtMzhhNS00ODRiLWE5OWYtNjI3OGFmZTRiOTQ1OTYxOGUwYWUtODQ1NC00ZDU2LWE2MDAtY2YwYzE4M2M2Zjg4%26view_type%3Dbusiness%26x-client-SKU%3DID_NET461%26x-client-ver%3D5.3.0.0',
    img: require('../../../../assets/wageworks.png'),
    p: ""
  },
  'Weeks Lerman': {
    href: 'https://weekslerman.com/',
    img: require('../../../../assets/weeks-lerman.png'),
    p: ""
  },
  'Worker\'s Compensation': {
    href: 'http://www.wcb.ny.gov/',
    img: require('../../../../assets/workers_compensation.png'),
    p: ""
  },
  'Zoom': {
    href: 'https://zoom.us/',
    img: require('../../../../assets/zoom.png'),
    p: ""
  }
}

const generateCards = (sectionObj) => {
  /*
    <p>
                                  {sectionObj[siteName].p}
                                </p>
  */
    return Object.keys(sectionObj).map((siteName) => {
        return (
        <Grid key={siteName} item xs={12} sm={12} md={12} lg={4} className={styles.cardsContainer}>
            <Grow direction="up" in={true} timeout={{enter: 900, exit: 0}}>
                <Card className={styles.card} >
                    <CardActionArea target='_blank' rel='noopener noreferrer' href={sectionObj[siteName].href}>
                        <div className={styles.cardLayout}>
                            <CardMedia
                              component="img"
                              alt={siteName}
                              className={styles.media}
                              //height="220"
                              src={sectionObj[siteName].img}
                              title={siteName}
                              />
                              <div className={styles.cardContent}> 
                                <h4 className={styles.linkLabel}>{siteName}</h4>
                              </div>
                        </div>
                    </CardActionArea>
                </Card>
             </Grow>
        </Grid>
        )
    })
}

const Body = () => {
  return (
  <Grid container className={styles.bodyContainer}>
    <Grid item xs={12} sm={12} md={12}>
      <h1 style={{textAlign: "center"}}>Human Resources</h1>
        <hr style={{width: '80%'}}/>
      <Grid container justify="center">
        {generateCards(humanResourcesSection)}
      </Grid>
    </Grid>
  </Grid>
  )
}

export default Body